/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ProductSearchCriteria,ProductLookupClause } from '@msdyn365-commerce/retail-proxy';
import {IAlternateProduct} from '../themes/adventureworks/views/common/buyboxInterface';
import { getByIdsAsync, searchByCriteriaAsync} from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { ProductAvailabilitiesForSelectedVariantInput, getProductAvailabilitiesForSelectedVariant,
    IProductInventoryInformation } from '@msdyn365-commerce-modules/retail-actions';
    import {getProductEtaAction,ProductEtaActionInput} from './product-eta-action.action';
import { getProductInfoAsync } from './getAlternateItemDetails';
import { ValueExtensionClass } from './AlternateItemsEntity.g';
// import { ProductDetailsExtensionClass } from './AlternateItemsEntity.g';
/**
 * GetAlternateItemsCollection Input Action
 */
export class GetAlternateItemsCollectionInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public productIds: string[];

    public config: any;
    constructor(prodIds: string[],config: any) {
        this.productIds = prodIds;
        this.config = config;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `TODO`;
    public getCacheObjectType = () => 'TODO';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IAlternateItems{
    dataAreaId: string;
    ItemId: string;
    AltItemId: string;
    UseAltItemId: string;
}

export interface IAlternateProductData {
    ItemId:string;
   currentProd: IAlternateProduct | undefined;
   serviceResp: IAlternateItems[] | undefined;
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetAlternateItemsCollectionData {
    respObj: IAlternateProductData[] | undefined;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
// const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
//     return new GetAlternateItemsCollectionInput();
// };

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getProductsAlternateItemsAction(input: GetAlternateItemsCollectionInput, ctx: Msdyn365.IActionContext): Promise<IGetAlternateItemsCollectionData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    const alterItems:IAlternateProductData[] = new Array();
    try{
    if(input.productIds !== null && input.productIds.length > 0)
    {
        const alternateProdDetails: ValueExtensionClass[] = await getProductInfoAsync({ callerContext: ctx, bypassCache: 'get' }, ctx,input.productIds.toString());
        for(let i=0; i < input.productIds.length; i++)
        {
            const item:IAlternateProductData = {ItemId: input.productIds[`${i}`],currentProd:undefined,serviceResp:undefined};
            if(alternateProdDetails)
            {
                const alternateDtls =  alternateProdDetails.find(data => data.ItemId === input.productIds[`${i}`]);
                if(alternateDtls)
                {
                     const currentAltItems: IAlternateItems[] = [];
                     currentAltItems.push({AltItemId: alternateDtls.AltItemId,dataAreaId: alternateDtls.dataAreaId,ItemId: alternateDtls.ItemId,UseAltItemId: alternateDtls.UseAltItemId});
                     item.serviceResp = currentAltItems;
                }
            }
            alterItems.push(item);
        }
        if(alterItems && alterItems.length > 0)
        {

            const productLookup:ProductLookupClause[] = new Array();
            alterItems.forEach((val:IAlternateProductData)=>{
                if(productLookup.length === 0 || (typeof productLookup.find(x => val.serviceResp && x.ItemId === val.serviceResp[0].AltItemId) === 'undefined'))
                {
                    const prodLookup:ProductLookupClause = {
                        ItemId : val.serviceResp && val.serviceResp[0].AltItemId};
                        productLookup.push(prodLookup);
                }
            });
            // const productLookup:ProductLookupClause[] = new Array();
            // const prodLookup:ProductLookupClause = {
            //     ItemId : item.serviceResp?.AltItemId};
            //     productLookup.push(prodLookup);
            const criteria:ProductSearchCriteria={
                Context:{CatalogId:ctx.requestContext.apiSettings.catalogId,ChannelId:ctx.requestContext.apiSettings.channelId},
                ItemIds:productLookup
            };
            var prodLists = await searchByCriteriaAsync({callerContext: ctx},criteria);
            if(prodLists && prodLists.length > 0)
            {
                    var altSampleProducts = await getByIdsAsync({callerContext: ctx}, ctx.requestContext.apiSettings.channelId, prodLists.map(prod => prod.RecordId));
                    alterItems.forEach((val:IAlternateProductData)=>{
                        if(val.serviceResp && val.serviceResp !== undefined && val.serviceResp.length > 0)
                        {
                            const sampleProd = altSampleProducts.find(x => val.serviceResp && x.ItemId === val.serviceResp[0].AltItemId);
                            if(sampleProd)
                            {
                                const alterProdDtl:IAlternateProduct = {productDtl: sampleProd,productAvailibility:null,etaDetails:undefined,inventoryLabel:undefined};
                                val.currentProd = alterProdDtl;
                            }
                        }
                    });

                for(var item=0; item<alterItems.length;item++)
                {
                    if(alterItems[`${item}`] && alterItems[`${item}`].currentProd && alterItems[`${item}`].currentProd?.productDtl)
                    {
                        let alterProdAvailability: IProductInventoryInformation[] | null = null;
                        let prodETA;
                        const dt = new ProductAvailabilitiesForSelectedVariantInput(alterItems[`${item}`].currentProd!.productDtl!.RecordId, ctx.requestContext.apiSettings.channelId);
                            alterProdAvailability = await getProductAvailabilitiesForSelectedVariant(dt,ctx);
                           const etaProdinpurt = new ProductEtaActionInput(alterItems[`${item}`].currentProd!.productDtl!.RecordId,ctx.requestContext.apiSettings.channelId,undefined);
                            if(alterItems && alterItems[`${item}`] && alterItems[`${item}`].currentProd)
                            {
                                alterItems[`${item}`]!.currentProd!.productAvailibility = alterProdAvailability;
                            }
                            if(input.config.requestContext.telemetryPageName !== 'Wishlist')
                            {
                                const alterProdEta = await getProductEtaAction(etaProdinpurt,ctx);
                                if(alterProdEta)
                                {
                                    prodETA = alterProdEta.etaObj;
                                }
                                if(alterItems && alterItems[`${item}`] && alterItems[`${item}`].currentProd)
                                {
                                    alterItems[`${item}`]!.currentProd!.etaDetails = prodETA;
                                }
                            }
                            // await getProductAvailabilitiesForSelectedVariant(new ProductAvailabilitiesForSelectedVariantInput(input.productId, ctx.requestContext.apiSettings.channelId),ctx);
                    }

                }
            }
        }
        }
    }
    catch(error)
    {
        ctx.telemetry.error(error);
    }
    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGetAlternateItemsCollectionData[]>('/get/example/id/1', 'get');
    return { respObj: alterItems};
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetAlternateItemsCollectionData>>getProductsAlternateItemsAction,
    // TODO: Give your data action a unique id
    id: 'GetAlternateItemsCollection'
    // input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
